import React from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export interface ImageElement {
  src: string;
  alt: string;
}

interface Props {
  open: boolean;
  handleClose: () => void;
  onSubmit?: () => void;
  image?: ImageElement;
  title: string;
  subtitle?: string;
  body?: JSX.Element;
}

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: "0.5rem",
  },
});

export const FlowDialog = ({
  open,
  handleClose,
  title,
  subtitle,
  image,
  body,
}: Props): JSX.Element => {
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      sx={{ borderRadius: "0.5rem" }}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle
        sx={{
          backgroundColor: "#F2F2FF",
          textAlign: "center",
          padding: "2rem 3rem",
        }}
      >
        {image && (
          <Box
            sx={{
              marginBottom: "1rem",
              marginTop: "0.5rem",
              "& img": {
                height: "5.75rem",
              },
            }}
          >
            <img src={image.src} alt={image.alt} />
          </Box>
        )}
        <Box sx={{ fontSize: "1.25rem" }}>{title}</Box>
        {subtitle && (
          <Typography
            sx={{
              marginTop: "1rem",
            }}
          >
            {subtitle}
          </Typography>
        )}
        {handleClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent sx={{ margin: "0 auto" }}>{body && body}</DialogContent>
    </StyledDialog>
  );
};
